// project imports
import { Logout } from 'utils/User';

// assets
import {
    IconDashboard,
    IconShadow,
    IconLogout,
    IconShare,
    IconGavel,
    IconInfoCircle,
    IconStar,
    IconUsers,
    IconLicense,
    IconPackages,
    IconChartBar,
    IconBuildingBank,
    IconBuildingSkyscraper,
    IconEdit,
    IconCalculator,
    IconReceipt,
    IconUserUp
} from '@tabler/icons-react';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = (basisId, access, badges) => {
    if (!basisId) return [];

    const hasAccess = (name, props) => {
        return access?.includes(name) ? [props] : [];
    };

    return [
        {
            id: 'dashboard',
            title: 'پیشخوان',
            type: 'group',
            children: [
                {
                    id: 'default',
                    title: 'پیشخوان',
                    type: 'item',
                    url: '/dashboard',
                    icon: IconDashboard,
                    breadcrumbs: false
                },
                ...hasAccess('MC', {
                    id: 'persons',
                    title: 'مخاطبان',
                    type: 'item',
                    url: `/basis/${basisId}/users?type=Person`,
                    icon: IconUsers,
                    breadcrumbs: false
                }),
                ...hasAccess('BA', {
                    id: 'accounts',
                    title: 'حساب‌های بانکی',
                    type: 'item',
                    url: `/basis/${basisId}/accounts`,
                    icon: IconBuildingBank,
                    breadcrumbs: false
                })
            ]
        },
        {
            id: 'sahmain',
            title: 'وجوهات',
            type: 'group',
            children: [
                ...hasAccess('RR', {
                    id: 'receipts',
                    title: 'رسیـدها',
                    type: 'item',
                    url: `/basis/${basisId}/receipts`,
                    icon: IconReceipt,
                    breadcrumbs: false,
                    ...(badges?.receipt ? { chip: { label: badges?.receipt?.toLocaleString(), color: 'warning', size: 'small' } } : {})
                }),
                ...hasAccess('CC', {
                    id: 'cheques',
                    title: 'چـک‌ها',
                    type: 'item',
                    url: `/basis/${basisId}/cheques`,
                    icon: IconPackages,
                    breadcrumbs: false
                }),
                ...hasAccess('PP', {
                    id: 'payments',
                    title: 'دریافت و پرداخت',
                    type: 'item',
                    url: `/basis/${basisId}/payments`,
                    icon: IconCalculator,
                    breadcrumbs: false
                }),
                ...hasAccess('RL', {
                    id: 'rentals',
                    title: 'عبادات استیجاری',
                    type: 'item',
                    url: `/basis/${basisId}/rentals`,
                    icon: IconLicense,
                    breadcrumbs: false
                }),
                ...hasAccess('RF', {
                    id: 'references',
                    title: 'دفتر مراجع تقلید',
                    type: 'item',
                    url: `/basis/${basisId}/references`,
                    icon: IconBuildingSkyscraper,
                    breadcrumbs: false
                }),
                ...hasAccess('RE', {
                    id: 'renters',
                    title: 'اجیـرها',
                    type: 'item',
                    url: `/basis/${basisId}/renters`,
                    icon: IconUserUp,
                    breadcrumbs: false
                }),
                {
                    id: 'reports',
                    title: 'گـزارش',
                    type: 'item',
                    url: `/basis/${basisId}/reports`,
                    icon: IconChartBar,
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'features',
            title: 'امکانات',
            type: 'group',
            children: [
                ...hasAccess('MO', {
                    id: 'users',
                    title: 'کاربران',
                    type: 'item',
                    url: `/basis/${basisId}/users?type=User`,
                    icon: IconUsers,
                    breadcrumbs: false
                }),
                ...hasAccess('MF', {
                    id: 'report_designer',
                    title: 'طراح گزارش',
                    type: 'item',
                    url: `/basis/${basisId}/report_designer`,
                    icon: IconEdit,
                    breadcrumbs: false
                }),
                {
                    id: 'about',
                    title: 'درباره‌ی ما',
                    type: 'item',
                    url: '/about',
                    icon: IconInfoCircle,
                    breadcrumbs: false
                },
                {
                    id: 'gavel',
                    title: 'قوانین و مقررات',
                    type: 'item',
                    url: '/terms',
                    icon: IconGavel,
                    breadcrumbs: false
                },
                {
                    id: 'share',
                    title: 'اشتراک‌گذاری برنامه',
                    type: 'item',
                    url: '/share',
                    icon: IconShare,
                    breadcrumbs: false
                },
                {
                    id: 'rate',
                    title: 'امتیاز به برنامه',
                    type: 'item',
                    url: '/rate',
                    icon: IconStar,
                    breadcrumbs: false
                },
                {
                    id: 'faq',
                    title: 'سؤالات متداول',
                    type: 'item',
                    url: '/faq',
                    icon: IconShadow,
                    breadcrumbs: false
                },
                {
                    id: 'logout',
                    title: 'خروج از حساب',
                    type: 'item',
                    url: '#',
                    onClick: Logout,
                    icon: IconLogout,
                    breadcrumbs: false
                }
            ]
        }
    ];
};

export default menuItems;
